export default {
    methods: {
      getProvinceString() {
        return this.$store.state.auth.portal_configuration?.province ?? 'Province';
      },
      getPostalCodeString() {
        return this.$store.state.auth.portal_configuration?.postalcode ?? 'Postal Code';
      }
    }
  };